const AVATAR_COLORS = [
	'#5B8DEF',
	'#E26D5A',
	'#5DBB8A',
	'#8B7CF6',
	'#F2A65A',
	'#3AAFA9',
	'#C06C84',
	'#6C9A8B'
];

export const getAvatarInitials = (email = '') => {
	const normalized = String(email || '').trim().toLowerCase();
	if (!normalized) return '?';

	const localPart = normalized.split('@')[0] || '';
	if (!localPart) return '?';

	const [firstSegment = '', secondSegment = ''] = localPart.split('.');
	const first = firstSegment.charAt(0).toUpperCase();
	const second = secondSegment.charAt(0).toUpperCase();

	return `${first}${second}`.trim() || '?';
};

export const getAvatarColorHex = (identifier = '') => {
	const normalized = String(identifier || '').trim().toLowerCase();
	if (!normalized) return '#6C9A8B';

	let hash = 0;
	for (let index = 0; index < normalized.length; index += 1) {
		hash = ((hash << 5) - hash) + normalized.charCodeAt(index);
		hash |= 0;
	}

	const colorIndex = Math.abs(hash) % AVATAR_COLORS.length;
	return AVATAR_COLORS[colorIndex];
};
